/**
 * Copyright Mántum All Rights Reserved.
 */
import Component from './component';
import Validator from '../validator';
import useEmpty from '../../../hooks/useEmpty';
import { EVENT_CLEAR, ACTION_VALUE, useGroupDispatch } from '../../group';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import type { Detail } from '@mantum/kanela';
import type { PropTypes } from './component';

export default forwardRef<Detail<unknown>, PropTypes>(
    function Input(props, ref) {
        // prettier-ignore
        const {
        error = false,
        name,
        optional = true,
        value = 0
    } = props;

        const dispatch = useGroupDispatch();

        const empty = useEmpty(optional);
        const inputRef = useRef<HTMLInputElement>(null);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name,
                    validable: !optional,
                    clear() {
                        if (name) {
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        return empty.validate(inputRef.current?.value);
                    },
                    value() {
                        return Number(inputRef.current?.value);
                    }
                };
            },
            [name, optional, empty, dispatch]
        );

        const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
            empty.validate(event.target.value);

            if (props.onBlur) {
                props.onBlur(event);
            }
        };

        return (
            <Validator
                error={empty.value || error}
                message={props.validation?.message}
                type='currency'
            >
                <Component
                    {...props}
                    error={empty.value || error}
                    onBlur={handleBlur}
                    onChange={props.onChange}
                    ref={inputRef}
                    value={value}
                />
            </Validator>
        );
    }
);
